import { render, staticRenderFns } from "./FormLayerStylePointSingleSymbol.vue?vue&type=template&id=60ef9228"
import script from "./FormLayerStylePointSingleSymbol.vue?vue&type=script&lang=js"
export * from "./FormLayerStylePointSingleSymbol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports